<template>
  <div class="noteManage">
    <tree-box title="短信配置" @sendID="getID" :showTree="isAction">
      <template slot="chose">
        <div class="chose-blank">
          <div class="checkAction">
            <p :class="{ action: isAction }" @click="isAction = true">
              推送配置
            </p>
            <p :class="{ action: !isAction }" @click="isAction = false" v-show="menusList.indexOf('SMS_LIMIT_CONFIG')!='-1'">
              额度配置
            </p>
          </div>
        </div>
      </template>
      <template slot="message" v-if="isAction">
        <h3>隐患选择</h3>
        <el-checkbox-group v-model="riskLevelList" class="checkItem">
          <el-checkbox
            v-for="item in riskType"
            :label="item.riskLevel"
            :key="item.riskLevel"
            >{{ item.levelName }}</el-checkbox
          >
        </el-checkbox-group>
        <h3>告警选择</h3>
        <el-checkbox-group v-model="faultList" class="checkItem">
          <el-checkbox
            v-for="item in faultType"
            :label="item.faultCode"
            :key="item.faultCode"
            >{{ item.faultName }}</el-checkbox
          >
        </el-checkbox-group>
        <h3>其它</h3>
        <el-checkbox-group v-model="otherEventList" class="checkItem">
          <el-checkbox
            v-for="item in otherEventType"
            :label="item.code"
            :key="item.code"
          >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
        <h3>推送配置</h3>
        <p>接收人员</p>
        <div class="checkItem">
          <el-checkbox
            v-model="noticeDeptManager"
            label="单位负责人"
          ></el-checkbox>
          <el-checkbox
            v-model="noticeMonitorManager"
            label="监测点负责人"
          ></el-checkbox>
          <span style="margin-left: 16px;color: #2A62FF;cursor: pointer;" @click="addList()"><img style="margin-right: 5px" src="../../../assets/station/addcon.png" alt="">新增其他（注：新增上限最多十个）</span>

        </div>
        <div class="other-phone">
          <div class="other-item" v-for="(item , index) in pushPersons">
            <span style="display: inline-block;width: 10px;">{{ index + 1 }}</span>.<span style="margin: 0 16px 0 6px;">人员</span>
            <span>
            <el-input style="width: 200px;" v-model="item.person" size="large"></el-input>
          </span>
         <span style="margin: 0 16px 0 26px;">手机号</span>
            <span>
            <el-input style="width: 200px;" v-model="item.phone" size="large"></el-input>
          </span>
            <span class="delete-item" @click="deletenow(index)">删除</span>
          </div>
        </div>
        <div class="btn-group">
          <el-button size="large" @click="saveConfig" type="primary"
            >保存</el-button
          >
          <el-button @click="queryAll" size="large">取消</el-button>
        </div>
        <div style="margin-top: 40px;font-size: 20px;">
          您的短信剩余额度/短信总额度：{{remainQuota}}/{{totalQuota}}
        </div>
      </template>
      <template slot="message" v-if="isAction==false">
          <div class="top-blank">
            <span class="changetips" @mouseenter="showtotips()" @mouseleave="leavetips()">
            <span style="display: inline-block;width: 30px;">
              {{nowtips}}
            </span>
              <img src="../../../assets/station/tipchange.png" alt="">
              <span class="gray-line"></span>
               <span class="change-item" v-show="showchange" @click="changetips">
                   {{downtips}}
              </span>
          </span>
            <span class="sp-input2">
                       <el-cascader
                         style="width: 300px"
                         size="large"
                         v-if="nowtips=='单位'"
                         :show-all-levels="false"
                         v-model="changeparm"
                         :options="deptList"
                         :placeholder=nowtips
                         :props="{
                  expandTrigger: 'hover',
                  value: 'deptId',
                  label: 'deptName',

                }"
                       ></el-cascader>
                  <el-select
                    v-model="changeparm"
                    :placeholder=nowtips
                    v-if="nowtips=='标签'"
                    style="width: 300px"
                    size="large"
                  >
                <el-option
                  v-for="item in labelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
          </span>
            <span class="sp-search" @click="queryTableList">
              <span><img src="../../../assets/station/fdj.png" alt=""></span>
            <span>查询</span>
          </span>
            <el-button type="primary" @click="addmessage" style="float: right;margin-right: 20px;">新增短信额度</el-button>
            <div class="table">
              <el-table v-loading="loading" :data="tableList">
                <el-table-column
                  prop="payer"
                  align="center"
                  label="付款方"
                ></el-table-column>
                <el-table-column prop="payment"  align="center" label="付费总额">

                </el-table-column>
                <el-table-column prop="smsLimit"  align="center" label="短信阈值">

                </el-table-column>
                <el-table-column prop="configName"  align="center" label="短信统计单位/标签">

                </el-table-column>
                <el-table-column prop="createTime"  align="center" label="设置时间">

                </el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                <span class="tableBtn" @click="showDialog(scope.row)">修改</span>
                <span class="tableBtn" @click="deletedata(scope.row)">删除</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="page">
              <el-pagination
                @current-change="pageChange"
                background
                :current-page="page"
                :page-size="sizePage"
                layout="total,prev, pager, next, jumper"
                :total="totalSum"
              >
              </el-pagination>
            </div>
          </div>
        <el-dialog
         title="额度配置"
          width="30%"
          :visible.sync="dialog"
          class="onDialog"
          :close-on-click-modal="false"
          :top="'20vh'"
        >
          <el-form
            label-width="100px"
            class="onDialog__form"
            :model="numform"
            ref="numform"
            :rules="rules2"
          >
            <el-row>
              <el-col :span="24" style="margin-left: 28px;margin-bottom: 18px;">

                  <el-radio v-model="configId" label="1">按单位配置</el-radio>
                  <el-radio v-model="configId" label="2">按标签配置</el-radio>

               </el-col>
              <el-col :span="12">
                <el-form-item :label="configId=='1'?'选择单位':'选择标签'" prop="pwd" >
                  <el-cascader
                    v-if="configId=='1'"
                    :show-all-levels="false"
                    v-model="numform.dep"
                    :options="deptList"

                    :props="{
                checkStrictly: true,
                  value: 'deptId',
                  label: 'deptName',

                }"
                  ></el-cascader>
                  <el-select
                    v-model="numform.dep"

                    v-if="configId=='2'"

                  >
                    <el-option
                      v-for="item in labelList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item
                ></el-col>
              <el-col :span="12">
                <el-form-item label="额度设置" prop="smsLimit" >
                  <el-input v-model="numform.smsLimit" />
                </el-form-item
                ></el-col>
              <el-col :span="12">
                <el-form-item label="付费方" prop="payer" >
                  <el-input v-model="numform.payer" />
                </el-form-item
                ></el-col>
              <el-col :span="12">
                <el-form-item label="付费总额" prop="payment" >
                  <el-input v-model="numform.payment" />
                </el-form-item
                ></el-col>
            </el-row>
          </el-form>

          <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="dialog = false">取 消</el-button>
      </span>
        </el-dialog>
        <el-dialog
          title="修改额度配置"
          width="30%"
          :visible.sync="changedia"
          class="onDialog"
          :close-on-click-modal="false"
          :top="'20vh'"
        >
          <el-form
            label-width="100px"
            class="onDialog__form"
            :model="numform"
            ref="numform"
            :rules="rules2"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="额度设置" prop="smsLimit" >
                  <el-input v-model="numform.smsLimit" />
                </el-form-item
                ></el-col>
              <el-col :span="12">
                <el-form-item label="付费方" prop="payer" >
                  <el-input v-model="numform.payer" />
                </el-form-item
                ></el-col>
              <el-col :span="12">
                <el-form-item label="付费总额" prop="payment" >
                  <el-input v-model="numform.payment" />
                </el-form-item
                ></el-col>
            </el-row>
          </el-form>

          <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadchange()">确 定</el-button>
        <el-button @click="canceldata()">取 消</el-button>
      </span>
        </el-dialog>
      </template>
    </tree-box>
  </div>
</template>

<script>
import Axios from "../../../utils/Axios";
import treeBox from "./components/treeBox";
import Vue from "vue";
export default {
  name: "noteManger",
  components: { treeBox },
  data() {
    return {
      isChange: false,
      configId: "1",
      dialog: false,
      isAction: true,
      showchange: false,
      page:1,
      numform:{
        dep:"",
        smsLimit:"",
        payment:"",
        payer:"",
      },
      changedia:false,
      sizePage:10,
      totalSum:null,
      checkList: "",
      deptId:15,
      deptList:[],
      pushPersons:[],
      noticeDeptManager: false,
      changeparm:"",
      noticeMonitorManager: false,
      nowtips:"单位",
      downtips:"标签",
      changeid:"",
      riskLevelList: [],
      otherEventList: [],
      riskType: [],
      loading:false,
      faultType: [],
      otherEventType: [],
      faultList: [],
      tipsList: [],
      labelList: [],
      tableList: [],
      menusList: [],
      form: {
        otherPhone: "",
      },
      rules: {
        otherPhone: [
          { required: false, trigger: "blur" },
          // 这个只能验证手机号
          // { pattern:/^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: "请输入合法手机号", trigger: "blur" }
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
            message: "请输入合法手机号/电话号",
            trigger: "blur",
          },
        ],
      },
      rules2:{


      },
      remainQuota:0,
      totalQuota:0,
    };
  },
  computed() {},
  methods: {
    deletenow(index){

      this.pushPersons.splice(index,1);
    },
    addList(){

      if(this.pushPersons.length < 10){
        this.pushPersons.push(
          {
          "person":"",
          "phone":"",
        }
        )
      }else{
        this.$message.warning("最多十个");
      }
    },
    deletedata(data){
      let that=this
      this.$confirm("确认删除？", '提示', {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        let param = {};
        param.method="post";

        param.url="/sms/limit/delete";
        param.data={
          id:data.id,

        }

        Axios.ajax(param).then((res)=>{

          if(res.resultCode=='0'){
            this.$message.success("删除成功！");


            this.queryTableList()
          }else{
            this.$message.warning(res.resultMessage);
          }
        })
      })
    },
    canceldata(){
      this.changedia=false
      this.numform={
        dep:"",
        smsLimit:"",
        payment:"",
        payer:"",
      }
    },
    getmessagenum(){
      let that = this;
      let param = {};
      param.method="post";

      param.url="/pushConfig/getSmsQuota";
      param.data={
        deptId:this.deptId,

      }

      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          this.remainQuota=res.data.remainQuota
          this.totalQuota=res.data.totalQuota
        }else{
          this.$message.warning(res.resultMessage);
        }
      })

    },
    uploadchange(){
      let that = this;
      let param = {};
      param.method="post";

      param.url="/sms/limit/update";
        param.data={
          id:this.changeid,
          "payer": this.numform.payer,
          "payment": this.numform.payment,
          "smsLimit": this.numform.smsLimit
        }

        Axios.ajax(param).then((res)=>{

          if(res.resultCode=='0'){
            this.$message.success("修改成功！");
            this.changedia=false
            this.numform={
              dep:"",
              smsLimit:"",
              payment:"",
              payer:"",
            }
            this.queryTableList()
          }else{
            this.$message.warning(res.resultMessage);
          }
        })

    },
    showDialog(data){

      this.changeid=data.id
      this.numform.payer=data.payer
      this.numform.payment=data.payment
      this.numform.smsLimit=data.smsLimit
      this.changedia=true
    },
    confirm(){
      let that = this;
      let param = {};
      param.method="post";
      if(this.configId){
        if(this.configId=='1'){
          param.url="/sms/limit/addDeptLimit";
        }else{
          param.url="/sms/limit/addLabelLimit";
        }

        param.data={
          "configId": this.numform.dep[this.numform.dep.length - 1],
          "payer": this.numform.payer,
          "payment": this.numform.payment,
          "smsLimit": this.numform.smsLimit
        }

        Axios.ajax(param).then((res)=>{

          if(res.resultCode=='0'){
            this.$message.success("新增成功！");
            this.dialog=false
            this.queryTableList()
          }else{
            this.$message.warning(res.resultMessage);
          }
        })
      }else{
        this.$message.warning("请先选择配置模式");
      }
    },
    pageChange(val) {
      this.page = val;
     this.queryTableList()
    },
    getpramData(){
      let that = this;
      let param3 = {};
      param3.method="get";
      param3.url="/dept/getDeptTree";
      param3.params={

      }
      Axios.ajax(param3).then((res)=>{

        if(res.data){
          that.deptList=res.data
          this.setName(that.deptList)
        }

      })
    },
    setName(datas){ //遍历树  获取id数组
      for(var i in datas){
        if(datas[i].deptType=='6' ){
          datas[i].disabled=false
        }else{
          datas[i].disabled=true
        }
        if(datas[i].children){
          this.setName(datas[i].children);
        }
      }

    },
    queryDepList() {
      const param = {};
      param.method = "post";
      param.url = "/label/findLabels";
      param.datas = {

      };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.labelList = res.data.map((item) => {
            return {
              value: item.labelId,
              label: item.labelName,
            };
          });

        }
      });
    },
    queryTableList() {
      this.loading = true;
      let par={

      }
      if( this.nowtips=="标签"){
        par.labelId=this.changeparm
        par.deptId=null

      }else{
        par.labelId=null
        par.deptId=this.changeparm
      }
      par.pageNum= this.page
      par.showNum= this.sizePage
      const params = {
        url: "/sms/limit/page",
        method: "post",
        data: par,
      };
      Axios.ajax(params).then(({ data }) => {

        this.loading = false;
        this.totalSum = data.totalNum;
        this.tableList = data.dataList;
      });
    },

    addmessage(){
    this.dialog=true
    },
    leavetips(){
      this.showchange=false
    },
    showtotips(){
      this.showchange=true
    },
    changetips(){
      if(this.nowtips=="单位"){
        this.nowtips="标签"
        this.downtips="单位"
      }else{
        this.nowtips="单位"
        this.downtips="标签"
      }
      this.showchange=false
    },
    saveConfig() {

      // this.$refs.form.validate((va) => {
      //   if (va) {
          const params = {
            url: "/pushConfig/savePushConfig",
            method: "post",
            data: {
              deptId: this.deptId,
              noticeDeptManager: this.noticeDeptManager,
              noticeMonitorManager: this.noticeMonitorManager,
              pushPersons: this.pushPersons,
              eventFaultCodeList: this.faultList,
              otherEventList: this.otherEventList,
              riskLevelList: this.riskLevelList,
            },
          };
          Axios.ajax(params).then((res) => {
            this.queryAll();
            if (res.resultCode == 0) {
              this.$message.success("保存成功");
            } else {
              this.$message.warning(res.resultMessage);
            }
          });
      //   }
      // });
    },
    getID(id) {
      this.deptId = id;
      this.getmessagenum()
      this.queryAll();
    },
    queryRiskLevels() {
      Axios.ajax({
        url: "/pushConfig/getRiskLevels",
        method: "post",
        data: {
          deptId: this.deptId,
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].checked == true) {
              this.riskLevelList.push(res.data[i].riskLevel);
            }
          }
          this.riskType = res.data;
        } else {
          this.$message.warning(res.resultMessage);
        }
      });
    },
    queryother() {
      Axios.ajax({
        url: "/pushConfig/getOtherEvents",
        method: "post",
        data: {
          deptId: this.deptId,
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].checked == true) {
              this.otherEventList.push(res.data[i].code);
            }
          }
          this.otherEventType = res.data;
        } else {
          this.$message.warning(res.resultMessage);
        }
      });
    },
    queryEventFaults() {
      Axios.ajax({
        url: "/pushConfig/getEventFaults",
        method: "post",
        data: {
          deptId: this.deptId,
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].checked == true) {
              this.faultList.push(res.data[i].faultCode);
            }
          }
          this.faultType = res.data;
        } else {
          this.$message.warning(res.resultMessage);
        }
      });
    },

    queryReceiverConfig() {
      Axios.ajax({
        url: "/pushConfig/getReceiverConfig",
        method: "post",
        data: {
          deptId: this.deptId,
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          this.noticeDeptManager = res.data.noticeDeptManager;
          this.noticeMonitorManager = res.data.noticeMonitorManager;
          this.pushPersons = res.data.pushPersons?res.data.pushPersons:[];
          if (this.form.otherPhone) {
            this.isChange = true;
          } else {
            this.isChange = false;
          }
        } else {
          this.$message.warning(res.resultMessage);
        }
      });
    },
    queryAll() {
      this.isChange = false;
      this.form.otherPhone = "";
      this.noticeDeptManager = false;
      this.noticeMonitorManager = false;
      this.faultList = [];
      this.riskLevelList = [];
      this.queryRiskLevels();
      this.queryother();
      this.queryEventFaults();
      this.queryReceiverConfig();
    },
  },
  created() {
    this.queryAll();
  },
  mounted() {

    this.menusList=Vue.prototype.menusList

    this.queryDepList()
    this.getpramData()
    this.queryTableList()
    this.queryother()
  },
};
</script>

<style lang="less" scoped>
.noteManage {
  .message {
    h3 {
      padding: 0 10px;
      border-left: 2px solid #2a62ff;
    }
    p {
      margin-top: 30px;
    }
    .checkItem {
      margin: 33px 0 20px 0;
    }
  }
}
.changetips{
  width:120px ;
  font-size: 14px;

  color: #7D879F;
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  cursor: pointer;
  img{
    margin-left: 6px;
  }
  .gray-line{
    display: inline-block;
    width: 1px;
    height: 18px;
    border: 1px solid #E4E7ED;
    margin-left: 6px;
  }

}
.sp-search{
  display:inline-block;
  font-size: 14px;
  width: 73px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #2A62FF;
  border-radius: 4px;
  color:#fff;
  position: relative;
  left: -4px;
  cursor: pointer;
  margin-right: 36px;
  img{
    position: relative;
    top: 12px;
    margin-right: 3px;
  }
}
.top-blank{
  position: relative;
}
.other-phone{
margin-bottom: 40px;
  margin-top: 10px;
  .delete-item{
    margin-left: 20px;
    color: #2A62FF;
    text-decoration:underline;
    cursor: pointer;
  }
}

.change-item{
  display: inline-block;
  position: absolute;
  top: 18px;
  left: -10px;
  width: 60px;
  height: 34px;
  background: #FFFFFF;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  border: 1px solid #E4E7ED;
  z-index: 100;

  font-size: 14px;

  color: #7D879F;
  text-align: center;
  line-height: 34px;

}
.table {
  height: 90%;
  overflow: auto;
  padding-top: 32px;
  .tableBtn {
    cursor: pointer;
    color: #2a62ff;
    margin-right: 12px;
  }
}
.other-item{
  margin-bottom: 10px;
}
.tip {
  width: 100%;
  text-align: center;
  padding: 20%;
  color: #7d879f;
  font-size: 16px;
}
.page {
float: right;
  margin-right: 26px;

}
</style>
<style  lang="less" scoped>
.chose-blank{
  background: #ffffff;
  border-radius: 4px;
  height: 60px;
  line-height: 60px;
  padding-left: 36px;
}
.checkAction {
  display: flex;
  p {
    cursor: pointer;
    width: 84px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    border-bottom: 2px solid #e4e7ed;
  }
  .action {
    color: #2a62ff;
    border-bottom: 2px solid #2a62ff;
  }
}
.table{
  height: 660px;
  overflow: auto;
}
</style>
<style lang="less">
.checkItem {
  display: flex;
  align-items: center;
  .el-checkbox {
    .el-checkbox__label {
      color: #252b3c;
      font-size: 14px !important;
    }
  }
}
#app .sp-input2 .el-input.el-input--large .el-input__inner{
  padding-left: 80px;
}
</style>
